import axios from 'axios';
import Bouncer from 'formbouncerjs/src/js/bouncer/bouncer';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import Forms from '../common/forms';

export default class Calculator {
    constructor() {
        this.section = document.querySelector('.component-calculator');
        this.form = this.section.querySelector('#calculatorForm');
        this.formFields = this.form.querySelectorAll('input, select, textarea');
        this.successMessage = this.section.querySelector('.component-calculator .success-form');
        this.errorMessage = this.section.querySelector('.component-calculator .error-form');
        this.btnSubmit = this.form.querySelector('button');

        this.allBtnToolTip = this.section.querySelectorAll('.toggle-tooltip');
        this.allToolTips = this.section.querySelectorAll('.tooltip');

        this.btnResetCaclulator = this.section.querySelectorAll('.btnResetCalculator');

        new Forms();

        this.ready();
        this.initRecaptcha();
    }

    ready() {
        const bouncer = new Bouncer(`#calculatorForm`, {
            ...Forms.config(),
            messages: Forms.messages(),
            customValidations: {
                isNotZero: function (field) {
                    return field.value === '0';
                },
            },
        });

        this.form.querySelectorAll('select[required]').forEach((select) => {
            select.setAttribute('data-bouncer-target', 'isNotZero');
        });

        this.form.addEventListener(
            'bouncerFormInvalid',
            () => {
                Forms.activeErros(this.form);
            },
            false
        );

        this.form.addEventListener(
            'bouncerFormValid',
            (event) => {
                event.preventDefault();
                if (event.target.id == this.form.id) {
                    this.sendForm(event.target);
                }
            },
            false
        );

        this.btnResetCaclulator.forEach((btn) => {
            btn.addEventListener('click', () => {
                this.resetCalculator();
            });
        });

        this.allBtnToolTip.forEach((button, index) => {
            const tooltip = button.nextElementSibling;

            if (!tooltip.id) {
                tooltip.id = `tooltip-${index}`;
            }
            button.setAttribute('aria-expanded', 'false');
            button.setAttribute('aria-describedby', tooltip.id);
            tooltip.setAttribute('role', 'tooltip');
            tooltip.setAttribute('aria-live', 'polite');
            tooltip.setAttribute('tabindex', '-1');

            const openTooltip = () => {
                this.allBtnToolTip.forEach((btn) => {
                    const t = btn.nextElementSibling;
                    t.classList.remove('opacity-100', 'pointer-events-auto', 'w-[15rem]', 'h-auto');
                    t.classList.add('opacity-0', 'pointer-events-none', 'w-0', 'h-0');
                    t.removeAttribute('data-tooltip-open');
                    btn.setAttribute('aria-expanded', 'false');
                });

                tooltip.classList.add('opacity-100', 'pointer-events-auto', 'w-[15rem]', 'h-auto');
                tooltip.classList.remove('opacity-0', 'pointer-events-none', 'w-0', 'h-0');
                tooltip.setAttribute('data-tooltip-open', 'true');
                button.setAttribute('aria-expanded', 'true');

                setTimeout(() => {
                    tooltip.focus();
                }, 100);
            };

            const closeTooltip = () => {
                tooltip.classList.add('opacity-0', 'pointer-events-none');
                tooltip.classList.remove('opacity-100', 'pointer-events-auto');
                tooltip.removeAttribute('data-tooltip-open');
                button.setAttribute('aria-expanded', 'false');
                button.focus();
            };

            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();

                const isOpen = tooltip.classList.contains('opacity-100');

                if (isOpen) {
                    closeTooltip();
                } else {
                    openTooltip();
                }
            });

            button.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    if (tooltip.classList.contains('opacity-100')) {
                        event.preventDefault();
                        event.stopPropagation();
                        closeTooltip();
                    }
                } else if (event.key === ' ' || event.key === 'Spacebar' || event.key === 'Enter') {
                    event.preventDefault();
                    event.stopPropagation();

                    const isOpen = tooltip.classList.contains('opacity-100');

                    if (isOpen) {
                        closeTooltip();
                    } else {
                        openTooltip();
                    }
                }
            });

            tooltip.addEventListener('keydown', (event) => {
                if (event.key === 'Escape' || event.key === 'Esc') {
                    event.preventDefault();
                    event.stopPropagation();
                    closeTooltip();
                }
            });
        });

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' || event.key === 'Esc') {
                const openTooltips = document.querySelectorAll('.tooltip[data-tooltip-open="true"]');
                if (openTooltips.length > 0) {
                    event.preventDefault();
                    event.stopPropagation();
                    openTooltips.forEach((tooltip) => {
                        tooltip.classList.add('opacity-0', 'pointer-events-none', 'w-0', 'h-0');
                        tooltip.classList.remove('opacity-100', 'pointer-events-auto', 'w-[15rem]', 'h-auto');
                        tooltip.removeAttribute('data-tooltip-open');

                        const button = tooltip.previousElementSibling;
                        if (button && button.classList.contains('toggle-tooltip')) {
                            button.setAttribute('aria-expanded', 'false');
                            button.focus();
                        }
                    });
                }
            }
        });
    }

    initRecaptcha() {
        this.formFields.forEach((field) => {
            field.addEventListener('focus', () => {
                if (!window.grecaptcha) {
                    window.loadRecaptchaV3();
                }
            });
        });
    }

    sendForm(form) {
        this.btnSubmit.disabled = true;

        this.btnSubmit.disabled = true;
        const dataForm = new FormData(form);
        const modifiedData = new FormData();

        dataForm.forEach((value, key) => {
            if (typeof value === 'string') {
                modifiedData.append(key, value.replace(/\./g, '').replace(/,/g, '.'));
            } else {
                modifiedData.append(key, value);
            }
        });

        axios({
            method: 'POST',
            url: base_url + 'calculator',
            data: modifiedData,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then((response) => {
                this.section.querySelector('#text-veiculo').innerHTML = response.data.dados_enviados.veiculo;
                this.section.querySelector('#text-numero_frota').innerHTML = response.data.dados_enviados.numero_frota;
                this.section.querySelector('#text-nome_oleo').innerHTML = response.data.produto_atual.produto;
                this.section.querySelector('#text-value-total-veiculo').innerHTML =
                    response.data.produto_atual.custo_veiculo;
                this.section.querySelector('#text-value-total').innerHTML = response.data.produto_atual.custo_total;

                this.section.querySelector('.swiper .swiper-wrapper').innerHTML = '';
                if (response.data.produto1) {
                    const template = this.templateSlider(
                        response.data.produto1.produto,
                        response.data.produto1.tempo_retorno,
                        response.data.produto1.economia,
                        response.data.produto1.custo_veiculo,
                        response.data.produto1.custo_total,
                        response.data.produto1.reducao_consumo,
                        response.data.produto1.economia_combustivel_litros,
                        response.data.produto1.economia_combustivel_custo
                    );
                    this.section.querySelector('.swiper .swiper-wrapper').insertAdjacentHTML('beforeend', template);
                }
                if (response.data.produto2) {
                    const template = this.templateSlider(
                        response.data.produto2.produto,
                        response.data.produto2.tempo_retorno,
                        response.data.produto2.economia,
                        response.data.produto2.custo_veiculo,
                        response.data.produto2.custo_total,
                        response.data.produto2.reducao_consumo,
                        response.data.produto2.economia_combustivel_litros,
                        response.data.produto2.economia_combustivel_custo
                    );
                    this.section.querySelector('.swiper .swiper-wrapper').insertAdjacentHTML('beforeend', template);
                }

                form.reset();
                this.section.querySelector('.calculatorForm').classList.remove('active');
                this.section.querySelector('.calculatorResults').classList.add('active');
                this.startSlider();

                const resultsSection = this.section.querySelector('.calculatorResults');
                resultsSection.scrollIntoView({ behavior: 'smooth' });

                setTimeout(() => {
                    const resultTitle = this.section.querySelector('#calculator-result-title');
                    if (resultTitle) {
                        resultTitle.setAttribute('tabindex', '-1');
                        resultTitle.focus();
                    }
                }, 500);
            })
            .catch((err) => {
                console.error('Erro: ', err);

                this.section.querySelector('.calculatorNoResults').classList.add('active');

                const noResultsSection = this.section.querySelector('.calculatorNoResults');
                noResultsSection.scrollIntoView({ behavior: 'smooth' });

                setTimeout(() => {
                    const noResultTitle = this.section.querySelector('#calculator-no-result-title');
                    if (noResultTitle) {
                        noResultTitle.setAttribute('tabindex', '-1');
                        noResultTitle.focus();
                    }
                }, 500);

                this.btnSubmit.disabled = false;
            });

        axios({
            method: 'POST',
            url: base_url + 'storeCalculator',
            data: dataForm,
            headers: { 'Content-Type': 'multipart/form-data' },
        })
            .then(() => {})
            .catch(() => {
                console.error('Erro ao enviar o formulário');
            });
    }

    startSlider() {
        const swiper = new Swiper(this.section.querySelector('.swiper'), {
            modules: [Navigation],
            grabCursor: true,
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1.3,
                    spaceBetween: 24,
                    navigation: false,
                    slidesOffsetBefore: 28,
                    slidesOffsetAfter: 28,
                },
                640: {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0,
                    navigation: {
                        nextEl: this.section.querySelector('.slider-button-next'),
                        prevEl: this.section.querySelector('.slider-button-prev'),
                    },
                },
            },
        });
    }

    templateSlider(produto, tempo, economia, veiculo, total, consumo, fuelLiters, fuelCost) {
        let fuelEconomySection = '';
        if (fuelLiters && fuelCost) {
            fuelEconomySection = `
                <div class="bg-white p-3 rounded-lg mb-6">
                    <div class="text-base/extra font-black text-center mb-3">Economia de Combustível</div>
                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra mb-2">
                        <div>Litros economizados/ano</div>
                        <div class="font-black"><span>${fuelLiters}</span> L</div>
                    </div>
                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra">
                        <div>Economia estimada/ano</div>
                        <div class="font-black">R$ <span>${fuelCost}</span></div>
                    </div>
                </div>
            `;
        }

        let template = `
            <div class="swiper-slide">
                <div class="bg-white p-3 rounded-lg mb-6">
                    <div class="flex items-center gap-4 text-base font-black mb-8"><svg width="14" height="19" viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1.80005 9C1.27416 9.91217 0.997561 10.9467 0.998048 11.9996C0.998534 13.0525 1.27608 14.0867 1.80282 14.9984C2.32955 15.9101 3.08692 16.6671 3.99885 17.1934C4.91077 17.7197 5.94514 17.9968 6.99805 17.9968C8.05095 17.9968 9.08532 17.7197 9.99725 17.1934C10.9092 16.6671 11.6665 15.9101 12.1933 14.9984C12.72 14.0867 12.9976 13.0525 12.998 11.9996C12.9985 10.9467 12.7219 9.91217 12.196 9L6.99905 1L1.79905 9H1.80005Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> <span id="text-nome_oleo">${produto}</span></div>

                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra mb-2">
                        <div>Custo total por veículo</div>
                        <div>R$ <span>${veiculo}</span></div>
                    </div>
                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra">
                        <div>Custo Total</div>
                        <div>R$ <span>${total}</span></div>
                    </div>
                </div>

                <div class="bg-white p-3 rounded-lg mb-6">
                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra mb-2">
                        <div>Economia Total Estimada</div>
                        <div class="font-black">R$ <span>${economia}</span></div>
                    </div>
                    <div class="flex items-center justify-between gap-6 font-medium text-sm/extra">
                        <div>Período de Payback</div>
                        <div class="font-black"><span>${tempo}</span> meses</div>
                    </div>
                </div>

                ${fuelEconomySection}

                <div class="bg-white p-3 rounded-lg mb-6">
                    <div class="text-base/extra font-black text-center mb-3">Redução de consumo de lubrificante</div>
                    <div class="w-auto flex items-center justify-center gap-3 font-medium text-sm/extra">
                        <div><svg xmlns="http://www.w3.org/2000/svg" width="14" height="18" fill="none"><path fill="currentColor" stroke="currentColor" stroke-width=".5" d="M12.114 6.502v.06c-.028.3-.268.642-.78.972-.536.344-1.318.636-2.27.815H9.06a.51.51 0 0 0-.405.59v.004a.51.51 0 0 0 .59.406l.002-.001c1.186-.222 2.18-.616 2.866-1.13v2.748c0 .224-.124.484-.422.754-.295.269-.74.526-1.316.738a.509.509 0 0 0 .352.955h.001a5.46 5.46 0 0 0 1.385-.725v2.157c0 .168-.088.371-.313.593-.223.221-.563.441-1.015.636-.902.39-2.209.663-3.788.663-1.58 0-2.886-.273-3.789-.662-.452-.196-.792-.416-1.015-.637-.225-.222-.313-.425-.313-.593v-2.154c.442.329 1.015.607 1.692.826l.005.002a.51.51 0 0 0 .634-.329.507.507 0 0 0-.327-.64c-.663-.213-1.175-.48-1.516-.766-.344-.288-.488-.57-.488-.818V8.227c.73.547 1.812.953 3.109 1.166h.002a.51.51 0 0 0 .582-.417.507.507 0 0 0-.416-.587h-.002c-1.004-.165-1.842-.46-2.422-.815-.593-.363-.853-.747-.853-1.072v-1.7c.473.337 1.089.616 1.797.825.951.28 2.089.44 3.32.44 1.23 0 2.367-.159 3.318-.44.709-.208 1.324-.487 1.798-.825v1.7ZM5.328 8.933a.257.257 0 0 0-.213-.297l-3.234-.728c.678.57 1.774 1.012 3.15 1.238a.26.26 0 0 0 .297-.213ZM7 .25c-1.675 0-3.182.296-4.28.792C1.64 1.53.867 2.256.867 3.157v11.686c0 .901.773 1.628 1.851 2.115 1.099.496 2.606.792 4.281.792 1.676 0 3.183-.296 4.281-.792 1.078-.487 1.852-1.214 1.852-2.115V3.157c0-.901-.774-1.628-1.852-2.115C10.183.546 8.676.25 7.001.25Zm0 1.018c1.578 0 2.885.273 3.788.663.452.195.792.415 1.016.636.225.222.313.425.313.593 0 .168-.088.371-.313.593-.223.22-.563.441-1.015.636-.903.39-2.21.663-3.789.663-1.58 0-2.886-.273-3.788-.663-.452-.195-.792-.415-1.016-.636-.224-.222-.312-.425-.312-.593 0-.168.088-.37.313-.593.223-.22.564-.44 1.016-.636.903-.39 2.21-.663 3.787-.663Z"/><path fill="currentColor" stroke="currentColor" stroke-width=".5" d="M9.485 2.556a1.81 1.81 0 0 0-.422.047c.127.04.297.07.507.073l-.085-.12Zm0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0H9.5m0 0H9.5m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0h.001m0 0c.209.003.377.034.505.073-.123.03-.275.049-.447.047l-.057-.12Zm.043 1.133H9.597c.567 0 1.11-.15 1.418-.469a.825.825 0 0 0 .248-.611v-.002c-.016-.398-.303-.667-.62-.826-.322-.16-.729-.24-1.118-.246h-.002c-.576-.005-1.142.143-1.458.466a.825.825 0 0 0-.248.612c.016.4.302.67.62.83.322.162.729.241 1.12.246ZM7.513 7.65l-.01-.01a.525.525 0 0 0-.372-.158c-.144 0-.28.06-.377.167-.134.148-.78.876-1.393 1.75-.306.436-.609.915-.835 1.38-.224.459-.387.93-.387 1.346a2.998 2.998 0 0 0 2.994 2.995 2.998 2.998 0 0 0 2.995-2.995c0-.415-.163-.886-.387-1.345a10.5 10.5 0 0 0-.836-1.38 20.206 20.206 0 0 0-1.392-1.75Zm-.382 6.451a1.979 1.979 0 0 1-1.977-1.976c0-.184.074-.442.218-.759.142-.31.342-.654.568-1 .382-.585.833-1.166 1.19-1.597.359.43.809 1.01 1.191 1.595.227.346.426.69.568 1 .145.317.218.576.218.761 0 1.09-.887 1.976-1.976 1.976Z"/><path fill="currentColor" stroke="currentColor" stroke-width=".5" d="M6.623 13.577c0 .278.225.509.51.509 1.081 0 1.96-.879 1.96-1.96a.51.51 0 1 0-1.018 0c0 .52-.424.944-.945.944a.508.508 0 0 0-.507.507Z"/></svg></div>
                        <div class="text-2xl font-black">${consumo}</div>
                        <div>Litros</div>
                    </div>
                </div>

            </div>
        `;
        return template;
    }

    resetCalculator() {
        this.form.reset();
        this.section.querySelector('#text-veiculo').innerHTML = '';
        this.section.querySelector('#text-numero_frota').innerHTML = '';
        this.section.querySelector('#text-nome_oleo').innerHTML = '';
        this.section.querySelector('#text-value-total-veiculo').innerHTML = '';
        this.section.querySelector('#text-value-total').innerHTML = '';
        this.section.querySelector('.swiper .swiper-wrapper').innerHTML = '';
        this.section.querySelector('.calculatorForm').classList.add('active');
        this.section.querySelector('.calculatorResults').classList.remove('active');
        this.section.querySelector('.calculatorNoResults').classList.remove('active');

        this.section.scrollIntoView({ behavior: 'smooth' });
    }
}
if (document.querySelector('.component-calculator')) {
    new Calculator();
}
